import { render, staticRenderFns } from "./ESituacaoAula.vue?vue&type=template&id=4b8b78d0"
import script from "./ESituacaoAula.vue?vue&type=script&lang=js"
export * from "./ESituacaoAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports